import { faAnchor } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import { INSERT_MEDIA_COMMAND } from "../../MediaPlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export function ExternalMedia()
{
    const [editor] = useLexicalComposerContext();
    const handleClick = () => editor.dispatchCommand(INSERT_MEDIA_COMMAND, 'https://www.youtube.com/watch?v=abcdefghijk');
    const element = <ToolbarButton title={'TODO'} icon={faAnchor} onClick={handleClick} />;
    return element;
}